import { jwtDecode } from "jwt-decode";

import Cookies from "js-cookie";

interface DecodedToken {
  exp: number;
  userId: string;
  appType: string;
  [key: string]: any;
}

export const isTokenExpired = (): boolean => {
  const token = Cookies.get("token");

  if (!token) {
    return true;
  }

  try {
    const decoded: DecodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    // Check if token is expired (with 30 second buffer)
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true;
  }
};

export const getTokenData = (): DecodedToken | null => {
  const token = Cookies.get("token");

  if (!token) {
    return null;
  }

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const clearAuthData = () => {
  Cookies.remove("token");
  // Clear any other auth-related data from localStorage if needed
  localStorage.removeItem("userData");
};
